export const taskTypes = {
  CREATE_TASK: "CREATE_TASK",
  GET_TASK: "GET_TASK",
  DELETE_TASK: "DELETE_TASK",
  EDIT_TASK: "EDIT_TASK",
  SET_TASK: "SET_TASK",
  GET_TASK_BY_ID: "GET_TASK_BY_ID",
  SET_TASK_BY_ID: "SET_TASK_BY_ID",
  IS_LOADING: "IS_LOADING",
  LEARNER_SUBMIT_TASK: "LEARNER_SUBMIT_TASK",
  APPROVE_TASK_SUBMIT: "APPROVE_TASK_SUBMIT",
};

export const createTask = (payload: any) => ({
  type: taskTypes.CREATE_TASK,
  payload,
});

export const getTask = (payload?: any) => ({
  type: taskTypes.GET_TASK,
  payload,
});

export const setTask = (payload: any) => ({
  type: taskTypes.SET_TASK,
  payload,
});

export const deleteTask = (payload: any) => ({
  type: taskTypes.DELETE_TASK,
  payload,
});

export const editTask = (payload: any) => ({
  type: taskTypes.EDIT_TASK,
  payload,
});

export const getTaskById = (payload: any) => ({
  type: taskTypes.GET_TASK_BY_ID,
  payload,
});

export const setTaskById = (payload: any) => ({
  type: taskTypes.SET_TASK_BY_ID,
  payload,
});

export const setTaskLoading = (payload: boolean) => ({
  type: taskTypes.IS_LOADING,
  payload,
});

export const approveTaskSubmit = (payload: any) => ({
  type: taskTypes.APPROVE_TASK_SUBMIT,
  payload,
});

export const learnerSubmitTask = (payload: any) => ({
  type: taskTypes.LEARNER_SUBMIT_TASK,
  payload,
});
